import React, { Component } from "react";
import Modal from "react-modal";

export default class ModalQuiz extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: true,
      correctAnswer: undefined,
      noOfQuestion: "1",
      shuff: undefined,
      questions: undefined,
      q1: undefined,
      a: "he",
      b: "he",
      c: "he",
      d: "he",
      hintUsed: false //state to hold if hint is used, if hint used you only get 250 points,
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  //This code is inspired by the source: https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
  shuffle = a => {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  };

  //End of inspired code

  //getting the index of the correct answer and of a random index from the array shuff
  //this is used when pressing hint button
  getindex = () => {
    this.setState({ hintUsed: true });
    let a = 0;
    // eslint-disable-next-line
    while (a <= 5 && this.state.shuff[a] != this.state.shuff[5]) {
      a = a + 1;
    }

    let b = Math.floor(Math.random() * 3);
    // eslint-disable-next-line
    while (b == a) {
      b = Math.floor(Math.random() * 3);
    }

    this.getbutton(a, b);
    // eslint-disable-next-line
    return a, b;
  };

  //setting state of all buttons to false and then change two of the to true
  //this will be used when pressing hint button
  getbutton = (i, y) => {
    this.setState({ a: false });
    this.setState({ b: false });
    this.setState({ c: false });
    this.setState({ d: false });

    // eslint-disable-next-line
    if (i == 0 || y == 0) {
      this.setState({ a: true });
    }
    // eslint-disable-next-line
    if (i == 1 || y == 1) {
      this.setState({ b: true });
    }
    // eslint-disable-next-line
    if (i == 2 || y == 2) {
      this.setState({ c: true });
    }
    // eslint-disable-next-line
    if (i == 3 || y == 3) {
      this.setState({ d: true });
    }
  };

  // If hint used you only get 250 points
  checkIfCorrectAnswer = (s1, s2) => {
    document.getElementById("answer-buttons").className = "disable-click";
    if (s1 === s2) {
      // points for quizzes is now dependent on which round the player is at.
      /// points is calculated by taking points * whichRound.
      if (this.state.hintUsed) {
        this.props.updateScore(
          250 * parseInt(localStorage.getItem("whichRound"), 10)
        );
      } else {
        this.props.updateScore(
          500 * parseInt(localStorage.getItem("whichRound"), 10)
        );
      }
      this.setState({
        correctAnswer: true
      });
    } else {
      this.setState({
        correctAnswer: false
      });
    }
    if (this.state.noOfQuestion === "1") {
      localStorage.setItem("ansone", true);
    } else if (this.state.noOfQuestion === "2") {
      localStorage.setItem("anstwo", true);
    }
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // to change text color in modal
    //this.subtitle.style.color = '#000000';
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  isitending = () => {
    if ((this.state.noOfQuestion === "2") & (this.props.whichRound === 3)) {
      this.props.itisending();
    }
  };

  componentDidMount() {
    if (
      this.state.questions === undefined ||
      !localStorage.hasOwnProperty("questionsFromAPI")
    ) {
      this.setState({
        questions: JSON.parse(localStorage.getItem("questionsFromAPI"))
      });
    }
    if (this.state.shuff === undefined && this.state.questions !== undefined) {
      let h = this.jfdsohfs();

      this.setState({
        shuff: h
      });
      localStorage.setItem("shuff", JSON.stringify(h));
    }

    if (
      localStorage.getItem("anstwo") === "true" &&
      localStorage.getItem("ansone") === "true"
    ) {
      localStorage.removeItem("shuff");
      this.closeModal();
      this.props.goToScoreBoardLvlTwo();
    }
    if (localStorage.getItem("ansone") === "true") {
      this.setState({
        correctAnswer: undefined,
        noOfQuestion: "2",
        shuff: undefined,
        questions: undefined,
        a: "he",
        b: "he",
        c: "he",
        d: "he",
        hintUsed: false //reset state
      });
      this.nextQuestion();
    }
    if (localStorage.hasOwnProperty("shuff")) {
      this.setState({
        shuff: JSON.parse(localStorage.getItem("shuff"))
      });
    }
  }

  componentDidUpdate() {
    if (
      this.state.questions === undefined ||
      !localStorage.hasOwnProperty("questionsFromAPI")
    ) {
      this.setState({
        questions: JSON.parse(localStorage.getItem("questionsFromAPI"))
      });
    }
    if (this.state.shuff === undefined && this.state.questions !== undefined) {
      let h = this.jfdsohfs();

      this.setState({
        shuff: h
      });
      localStorage.setItem("shuff", JSON.stringify(h));
    }
  }

  // This function decodes HTML characters. We use this when fetching from quiz API.
  decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  jfdsohfs = () => {
    let i;
    if (this.state.noOfQuestion === "1") {
      i = Math.floor(Math.random() * (this.state.questions.length - 1));
      this.setState({
        q1: this.state.questions[i].question
      });
    } else {
      i = Math.floor(Math.random() * (this.state.questions.length - 1));
      while (this.state.questions[i].question === this.state.q1) {
        i = Math.floor(Math.random() * (this.state.questions.length - 1));
      }
    }

    let q = this.decodeHtml(this.state.questions[i].question);
    let answerOne = this.decodeHtml(this.state.questions[i].correct_answer);
    let answerTwo = this.decodeHtml(
      this.state.questions[i].incorrect_answers[0]
    );
    let answerThree = this.decodeHtml(
      this.state.questions[i].incorrect_answers[1]
    );
    let answerFour = this.decodeHtml(
      this.state.questions[i].incorrect_answers[2]
    );
    let c = this.decodeHtml(this.state.questions[i].correct_answer);

    let answers = [answerOne, answerTwo, answerThree, answerFour];
    let ranAnswers = this.shuffle(answers);
    let r = ranAnswers.concat(q);
    let b = r.concat(c);
    return b;
  };

  // Reset all states
  nextQuestion = () => {
    if (this.state.noOfQuestion === "2") {
      localStorage.removeItem("shuff");
      this.closeModal();
      this.props.goToScoreBoardLvlTwo();
    } else {
      this.setState({
        correctAnswer: undefined,
        noOfQuestion: "2",
        shuff: undefined,
        questions: undefined,
        a: "he",
        b: "he",
        c: "he",
        d: "he",
        hintUsed: false //reset state
      });
    }
  };

  hintsFinder = () => {
    let a;
    let i = Math.floor(Math.random() * 3);
    while (this.state.shuff[i] === this.state.shuff[5]) {
      i = Math.floor(Math.random() * 3);
    }
    let b = a.concat(this.state.shuff[5]);
    let c = b.concat(this.state.shuff[i]);
    return c;
  };

  checkNoOfHints = () => {
    if (!localStorage.hasOwnProperty("noOfHints")) {
      localStorage.setItem("noOfHints", 0);
      return true;
    } else {
      if (parseInt(localStorage.getItem("noOfHints")) === 0) return true;
      else if (parseInt(localStorage.getItem("noOfHints")) === 1) return true;
      else return false;
    }
  };

  increaseHints = () => {
    let i;
    i = parseInt(localStorage.getItem("noOfHints"));
    localStorage.setItem("noOfHints", i + 1);
  };

  render() {
    return (
      <div>
        {this.state.shuff !== undefined && (
          <Modal
            className="quiz-modal"
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            shouldFocusAfterRender={false}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            contentLabel="Example Modal"
          >
            <button
              disabled={!this.checkNoOfHints()}
              className="hint-button"
              onClick={() => {
                this.getindex();
                this.increaseHints();
              }}
            >
              Hint
            </button>

            <center>
              <h2>{this.state.noOfQuestion} out of 2 </h2>
              <h2 className="Modal-head">
                <span style={{ color: "#52b452dc" }}>
                  Can you guess the answer?
                </span>
              </h2>
            </center>
            <div>
              <div
                className="content-Modal"
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                contentLabel="Example Modal"
              />
            </div>
            <center>
              <div className="Mini-text" />
              <p className="question-field">{this.state.shuff[4]}</p>
            </center>
            <center>
              <p className="quiz-info-text">
                Think closely, as you have only one guess.
              </p>
            </center>
            <div id="answer-buttons">
              <center>
                <button
                  disabled={!this.state.a}
                  onClick={() => {
                    this.checkIfCorrectAnswer(
                      this.state.shuff[5],
                      this.state.shuff[0]
                    );
                  }}
                  className="option-button"
                >
                  A. {this.state.shuff[0]}
                </button>

                <button
                  disabled={!this.state.b}
                  onClick={() => {
                    this.checkIfCorrectAnswer(
                      this.state.shuff[5],
                      this.state.shuff[1]
                    );
                  }}
                  className="option-button"
                >
                  B. {this.state.shuff[1]}
                </button>

                <button
                  disabled={!this.state.c}
                  onClick={() => {
                    this.checkIfCorrectAnswer(
                      this.state.shuff[5],
                      this.state.shuff[2]
                    );
                  }}
                  className="option-button"
                >
                  C. {this.state.shuff[2]}
                </button>

                <button
                  disabled={!this.state.d}
                  onClick={() => {
                    this.checkIfCorrectAnswer(
                      this.state.shuff[5],
                      this.state.shuff[3]
                    );
                  }}
                  className="option-button"
                >
                  D. {this.state.shuff[3]}
                </button>
              </center>
            </div>
            <div className="quiz-modal--footer">
              <div />

              {this.state.correctAnswer && (
                <p className="correct-wrong-quiz">
                  You answered{" "}
                  <span style={{ color: "green" }}>correctly!</span>
                </p>
              )}

              {this.state.correctAnswer === false && (
                <p className="correct-wrong-quiz">
                  {" "}
                  <span style={{ color: "red" }}>Wrong answer. </span>The
                  correct answer was{" "}
                  <span style={{ fontWeight: "900" }}>
                    {this.state.shuff[5]}.
                  </span>
                </p>
              )}
              <div>
                <button
                  disabled={this.state.correctAnswer === undefined}
                  className="cta-button"
                  onClick={() => {
                    this.nextQuestion();
                    this.isitending();
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}
